var $33849b7695cd3116$exports = {};
$33849b7695cd3116$exports = {
    "expand": `Expand`,
    "collapse": `Collapse`
};


export {$33849b7695cd3116$exports as default};
//# sourceMappingURL=en-US.mjs.map
